import React from 'react';
import Images from '../UI/Image/Image';

export const internet = {
    offline: null,
};

export const CheckOffline = (props) => {
    return <div className="offline">
        <Images src={internet.offline} />
        <span>Network connectivity lost</span>
    </div>;    
};
